import api from './api';

export async function getOwnerReport(venueId, startDate, endDate, paymentWindow, activityType = 'All') {
  const response = await api.get(`/reports/venues/${venueId}/owner-dashboard`, {
    params: {
      startDate,
      endDate,
      activityType,
      ...(paymentWindow ? {
        paymentStartDateTime: paymentWindow.start,
        paymentEndDateTime: paymentWindow.end,
      } : {}),
    },
  });
  return response.data;
}

export async function getVenueEarningsReport(venueId, startDate, endDate) {
  const response = await api.get(`/reports/venues/${venueId}/earnings`, {
    params: { startDate, endDate },
  });
  return response.data;
}

export async function getBookingDetailsFilterOptions() {
  const response = await api.get('/reports/booking-details/filter-options');
  return response.data;
}

export async function getBookingDetailsReport(params) {
  const response = await api.get('/reports/booking-details', { params });
  return response.data;
}
